import { forwardRef } from 'react';

import { getCurrencySymbol } from 'components/Fields/helpers';
import PriceNumberInline from 'components/Inputs/inline/TextInput/presets/PriceNumber';
import { withCellWrapper } from './helpers';

const _PriceNumberCell = forwardRef(
  (
    {
      field,
      entityId,
      entityAccess,
      onSubmit,
      value,
      objectId,
      serviceToUse,
      fetchUrl,
      handleUpdateFieldOption,
      handleUpdateTableRecords,
      menuLeftButton,
      menuRightButton,
      placeholder,
      info,
      showDisplayNameTooltip,
      column,
      readOnly,
      onAutoFocus,
      ...others
    },
    ref
  ) => {
    return (
      <PriceNumberInline
        ref={ref}
        {...others}
        field={field}
        entityId={entityId}
        value={value}
        onSubmit={onSubmit}
        readOnly={readOnly}
        onAutoFocus={onAutoFocus}
        currencySymbol={getCurrencySymbol(field)}
      />
    );
  }
);

export const PriceNumberCell = withCellWrapper(_PriceNumberCell);
